import ContentHeading from "@/components/content-heading";
import React from "react";
import {useTranslation} from "react-i18next";
import RadioItems from "@/components/pages/media/radio-interviews/radio-items";
import {radioWrapper} from "@/components/pages/media/radio-interviews/style";

const RadioInterviews = () => {
    const {t} = useTranslation();
    return <section className={radioWrapper}>
        <ContentHeading h={"h3"}
                        className={"justify-center"}
                        backdropPosition={"left-4"}
                        fontSize={"mobile:text-3xl tablet:text-5xl"}
                        background={"bg-primary bg-opacity-40"}>
            {t("media.radio-interview-section.heading")}
        </ContentHeading>
        <RadioItems/>
    </section>
}

export default RadioInterviews